import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display } from '../../utils/configuredReportFormatters'

export const activePropertiesColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'company_name',
    label: 'Company',
    sortKey: 'company_name',
    render: (row) => display(row.company_name),
  },
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) => display(row.property_name),
  },
  {
    id: 'property_city',
    label: 'City',
    sortKey: 'property_city',
    render: (row) => display(row.property_city),
  },
  {
    id: 'property_state',
    label: 'State',
    sortKey: 'property_state',
    render: (row) => display(row.property_state),
  },
  {
    id: 'property_zipcode',
    label: 'Zip',
    sortKey: 'property_zipcode',
    render: (row) => display(row.property_zipcode),
  },
  {
    id: 'teamname',
    label: 'Sales Team',
    sortKey: 'teamname',
    render: (row) => display(row.teamname),
  },
  {
    id: 'invitations',
    label: 'Invitations',
    sortKey: 'invitations',
    render: (row) => display(row.invitations),
  },
  {
    id: 'apps_started',
    label: 'Apps Started',
    sortKey: 'apps_started',
    render: (row) => display(row.apps_started),
  },
  {
    id: 'apps_completed',
    label: 'Apps Completed',
    sortKey: 'apps_completed',
    render: (row) => display(row.apps_completed),
  },
  {
    id: 'apps_awaiting',
    label: 'Apps Awaiting',
    sortKey: 'apps_awaiting',
    render: (row) => display(row.apps_awaiting),
  },
  {
    id: 'approved_app',
    label: 'Approved App',
    sortKey: 'approved_app',
    render: (row) => display(row.approved_app),
  },
  {
    id: 'certificates_bought_apps',
    label: 'Certificates Bought',
    sortKey: 'certificates_bought_apps',
    render: (row) => display(row.certificates_bought_apps),
  },
  {
    id: 'inactive_3months',
    label: 'Inactive 3 Months',
    sortKey: 'inactive_3months',
    render: (row) => display(row.inactive_3months),
  },
  {
    id: 'listed',
    label: 'Listed',
    sortKey: 'listed',
    render: (row) =>
      String(row.listed ?? '') === '1' ? 'Active' : 'Not Active',
  },
  {
    id: 'occupancy',
    label: 'Occupancy',
    sortKey: 'occupancy',
    render: (row) => display(row.occupancy ?? row['occupancy ']),
  },
]
